import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1b75bc'
    },
    background: {
      default: '#ededed'
    }
  }
});

export default theme;
